import { format } from 'date-fns'
import clsx from 'clsx'
import BigNumber from 'bignumber.js'
import numberFormat from '@/utils/numberFormat'

export default function SettlementHistoryRow({ history }) {
  const { old_balance, new_balance, settled_amount, settled_time } = history
  const displayConfig = { formatKey: 'max8', signDisplay: true }
  return (
    <tr className="table-list-row">
      <td className="table-list-cell align-left">
        <span
          className={clsx({
            'color-positive': BigNumber(old_balance).gt(0),
            'color-negative': BigNumber(old_balance).lt(0)
          })}
        >
          {numberFormat(old_balance, displayConfig)}
        </span>
        <span className="arrow-symbol">→</span>
        <span
          className={clsx({
            'color-positive': BigNumber(new_balance).gt(0),
            'color-negative': BigNumber(new_balance).lt(0)
          })}
        >
          {numberFormat(new_balance, displayConfig)}
        </span>
      </td>
      <td className="table-list-cell align-left">
        <span
          className={clsx({
            'color-positive': BigNumber(settled_amount).gt(0),
            'color-negative': BigNumber(settled_amount).lt(0)
          })}
        >
          {numberFormat(settled_amount, displayConfig)}
        </span>
        <span className="token-symbol">USDC</span>
      </td>
      <td className="table-list-cell align-right">
        {format(settled_time, 'yyyy-MM-dd HH:mm:ss')}
      </td>
    </tr>
  )
}
